<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-7 p-0">
        <!-- <img
          class="bg-img-cover bg-center "
          height="100%"
          style="opacity: 0.76;"
          src="../../assets/images/login/2.jpg"
          alt="looginpage"
        /> -->
      </div>
      <div class="col-xl-5 p-0">
        <div class="login-card">
          <div>
            <h5 class="text-center">SEGUIMIENTO Y EVALUACIÓN DEL SISTEMA AUTOMATIZADO</h5>
            <h6 class="text-center">“ESTADO DIGITAL - CONTROL MIGRATORIO ED-2”</h6>
            <div class="login-main login-form-card mt-2">
              <!-- <form class="theme-form" @submit.prevent="login"> -->
              <h4>Acceso al sistema</h4>
              <p>Ingrese su usuario y contraseña</p>
              <div class="form-group">
                <label class="col-form-label">Usuario:</label>
                <input
                  class="form-control"
                  type="text"
                  required=""
                  placeholder="Usuario"
                  v-model.trim="usuario.usr_usuario"
                />
              </div>
              <div class="form-group">
                <label class="col-form-label">Contraseña:</label>
                <input
                  class="form-control"
                  type="password"
                  name="login[password]"
                  required=""
                  placeholder="*********"
                  v-model.trim="usuario.usr_password"
                />
              </div>
        <div class="form-group mb-0">
                <button
                  type="button"
                  class="btn btn-success btn-block"
                  @click="login"
                >
                  INGRESAR
                </button>
          <!--      <br />
           <a @click="showModal" href="#" class="text-info"
             >Olvidé mi contraseña</a
           >-->
         </div>
         <!--     <p class="mt-4 mb-0">
          ¿No tiene una cuenta aún? Crear Cuenta
        </p>
-->
              <div class="row mt-3">
                <!--   <div class="col-md-6">
                   <router-link
                     to="/empresa/RegistrarmeEmpadronamiento"
                     class="btn btn-warning btn-block"
                     >Cuenta Empresa</router-link
                   >
                 </div>

                <div class="col-md-6">
                   <router-link
                     to="/extranjero/EmpadronarExtranjero"
                     class="btn btn-success btn-block"
                     >Cuenta Extranjero</router-link
                   >
                 </div>
                <div class="col-md-6">
                  <a @click="showModalTipo" class="btn btn-success btn-block"
                    >Cuenta Extranjero</a
                  >
                </div>-->
              </div>
             <!-- <div class="row mt-3">
                <div
                  class="alert alert-warning"
                  role="alert"
                  style="background-color: rgba(248, 214, 43, 0.1);color:#000;"
                >
                  <i class="fa fa-exclamation-triangle"></i>
                  En caso de tener dificultades para ingresar al Sistema
                  comunicarse a Digemig <b>(591-2) 2110960 interno 116 - 117</b>
                </div>
              </div>-->
              <br />
             <!--   <a @click="download" href="#" class="text-info"
                  >Descargas</a
                >
               
              <p>Tutoriales: <a href="https://www.youtube.com/channel/UCawaNWBZbHor-IqHwE7jXvA" class="text-info">youtube.com/SoporteDIGEMIG</a></p>
-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="cargando" />
    <b-modal
      class="modal fade"
      hide-footer
      title="RECUPERA TU CONTRASEÑA"
      ref="modalRecupera"
      size="md"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row">
          <div class="col-12 col-md-12"></div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-md-12">
            <div
              class="alert alert-warning"
              style="background-color: rgba(248, 214, 43, 0.1);color:#000;"
            >
              Si tiene una cuenta como empresa o extranjero y olvidó su
              contraseña, ingrese su correo electrónico
            </div>
            <input
              type="text"
              placeholder="Correo Electrónico"
              class="form-control"
              v-model="correoRecupera"
              required
              :class="{ 'is-invalid': $v.correoRecupera.$error }"
            />
            <hr />
            <a class="btn btn-success" @click="recupera">Enviar</a>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      class="modal fade"
      hide-footer
      title="SELECCIONE CUENTA"
      ref="modalTipo"
      size="md"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row">
          <div class="col-12 col-md-12"></div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-md-12">
            <div
              class="alert alert-warning"
              style="background-color: rgba(248, 214, 43, 0.1);color:#000;"
            >
              Si esta creando su usuario por primera vez elija el tipo de
              cuenta correspondiente a:
            </div>

            <hr />
            <div class="row">
              <div class="col-12 col-md-6">
                <RouterLink
                  class="btn btn-success btn-block"
                  :to="{
                    path: `/extranjero/EmpadronarExtranjero/${this.turismo}`,
                  }"
                  >Turista
                </RouterLink>
              </div>
              <div class="col-12 col-md-6">
                <RouterLink
                  class="btn btn-success btn-block"
                  :to="{
                    path: `/extranjero/EmpadronarExtranjero/${this.residente}`,
                  }"
                  >Residente
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "../../components/Loading";
import { required, email } from "vuelidate/lib/validators";
import FileSaver from "file-saver";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      turismo: 1,
      residente: 2,
      usuario: { usr_usuario: "", usr_password: "" },
      cargando: false,
      valido: false,
      correoRecupera: "",
    };
  },
  methods: {
    ...mapActions(["guardarUsuario"]),
    showModal() {
      this.$refs["modalRecupera"].show();
    },
    hideModal() {
      this.$refs["modalRecupera"].hide();
      this.correoRecupera = "";
    },

    showModalTipo() {
      this.$refs["modalTipo"].show();
    },
    hideModalTipo() {
      this.$refs["modalTipo"].hide();
      this.correoRecupera = "";
    },
    async login() {
      this.cargando = true;
      try {
        let res = await this.axios.post(`/login`, this.usuario);

        if (Number(res.status) == 400 || Number(res.status) == 500) {
          this.cargando = false;
          this.$swal({
            html: "Usuario o contraseña incorrectos",
            type: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#51bb25 !important",
          });
        } else {
          this.cargando = false;
          const token = res.data.contenido.token;

          this.guardarUsuario(token);
        }
      } catch (error) {
        this.cargando = false;
        this.$swal({
          html: "Usuario o contraseña incorrectos",
          type: "info",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#51bb25",
        });
      }
    },
     async download() {
      try {
        let resultados = await this.axios.get("/descarga_manual", {
          responseType: "blob",
        });
        if (resultados.status == 200) {
          let file = new Blob([resultados.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileSaver.saveAs(file, "manual.pdf");
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async recupera() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }

      if (this.correoRecupera != "" && this.correoRecupera != undefined) {
        this.cargando = true;
        let dato = {
          correoRecupera: this.correoRecupera,
        };
        try {
          let res = await this.axios.post(`/recuperaCorreo`, dato);
          this.cargando = false;
          this.hideModal();
          let clase = "success";
          if (res.data.codigo == 0) {
            clase = "error";
          }
          this.$swal({
            html: res.data.mensaje,
            type: clase,
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#51bb25",
          });
        } catch (error) {
          this.hideModal();
          this.cargando = false;
          this.$swal({
            html: "Existe un error, vuelva a intentarlo",
            type: "error",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#51bb25",
          });
          console.log(error);
        }
      }
    },
  },
  validations: {
    correoRecupera: { required, email },
  },
};
</script>
